import TransportSection from './TransportSection';

const CombinedSection = () => {
  return (
    <div className="py-16 bg-gray/50">
      <TransportSection />
    </div>
  );
};

export default CombinedSection;
